import axios, { API } from 'lib/config/axios';
import useAppNavigator from 'views/rebranded-module/common/hooks/useAppNavigator';

export const usePageApiRequests = () => {
  const appNavigator = useAppNavigator();
  const getReviewsData = (page) => axios.get(API.vehicleReservationFeedbacks, {
    params: {
      page,
    },
  });

  const getLocationReviewsData = (page) => axios.get(
    API.vehicleReservationFeedbacksByLocation.replace(
      '{identifier}',
      appNavigator.query.id,
    ),
    {
      params: {
        page,
      },
    },
  );
  return [getReviewsData, getLocationReviewsData];
};
